module.exports = __webpack_public_path__ + "img/matias-selva.9da8ea7a.jpg";